import { ImageWrapper } from './PrimaryIcon.styles';
import { getImageUrl } from './PrimaryIcon.utils';

export const PrimaryIcon = () => (
  <ImageWrapper src={getImageUrl()} alt="Sembo Logo" />
);
